import React, { Suspense } from 'react'
import parse from "html-react-parser"
import { styled } from '../../../../stitches.config'
import LazyLoad from "react-lazyload"

import { INSTAGRAM_POST_REGEX, TWITTER_REGEX, TIKTOK_REGEX, INFOGRAM_REGEX } from "../../../common/constants/constants"
import TwitterPost from "../../Content/body/TwitterPost"
import FacebookPost from "../../Content/body/FacebookPost"
import InstagramPost from "../../Content/body/InstagramPost"
import TiktokEmbed from "../../Content/body/TiktokEmbed"
import TelegramPost from "../../Content/body/TelegramPost"
import { EmbedElement } from "./types"

import InfogramPost from "../../Content/body/InfogramPost"

type MediaEmbedProps = {
    element: EmbedElement
}

const MediaEmbed: React.FC<MediaEmbedProps> = ({ element }) => {
    const options = {
        replace: (domNode: any) => {
            console.log(domNode)
            if (domNode.name === "script" && domNode.attribs) {
                if (domNode.attribs.src && domNode.attribs.src.length > 1) {
                    const s = document.createElement("script");
                    s.type = "text/javascript";
                    s.async = true;
                    s.src = domNode.attribs.src;
                    document.getElementsByTagName("body")[0].appendChild(s);
                    return <React.Fragment></React.Fragment>;

                } else if (domNode.attribs.type === 'text/javascript') {
                    const script = (domNode.children[0] ? domNode.children[0].data : null);
                    setTimeout(() => window.eval(script), 1000);
                    return <React.Fragment></React.Fragment>;
                }
            }
        }
    }
    return (
        <div>
            <LazyLoad once={true} offset={400} height={350}>
                <EmbedWrapper>
                    {
                        (() => {
                            switch (element.embedType) {
                                case "youtube":
                                    return <YTEmbedWrapper>
                                        <iframe
                                            src={element.url}
                                            frameBorder="0"
                                            allow="autoplay; encrypted-media"
                                            allowFullScreen>
                                        </iframe>
                                    </YTEmbedWrapper>
                                case "twitter":
                                    const twitterMatch = element.url.match(TWITTER_REGEX)
                                    return <TwitterPost dataId={element.liveId ? element.liveId : twitterMatch![2]} />
                                case "instagram":
                                    const dataIdInstagram = element.url.match(INSTAGRAM_POST_REGEX)
                                    return <InstagramPost dataId={element.liveId ? element.liveId : dataIdInstagram![1]} />
                                case "tiktok":
                                    const [_, tiktokProfileId, tiktokVideoId] = element.url.match(TIKTOK_REGEX)!
                                    return <TiktokEmbed profile={tiktokProfileId} videoId={tiktokVideoId} />
                                case "facebook":
                                    return <FacebookPost href={element.url} />
                                case "facebook-video":
                                    return <FacebookPost href={element.url} type="video" />
                                case "telegram":
                                    return <TelegramPost url={element.url} />
                                case "googleMaps":
                                    return <iframe src={element.url} width="600" height="450" frameBorder="0" allowFullScreen={true} />
                                case "onnetwork_iframe":
                                    return <OnnetworkIframe>
                                        <iframe
                                            src={element.url}
                                            frameBorder="0"
                                            allow="autoplay; encrypted-media" allowFullScreen>
                                        </iframe>
                                    </OnnetworkIframe>
                                case "infogram":
                                    return <InfogramPost url={element.url} />
                                case "wykres":
                                    return <iframe
                                        src={element.url}
                                        width="100%"
                                        height='400px'
                                        frameBorder="0"
                                        allowFullScreen>
                                    </iframe>
                                case "default":
                                default:
                                    return <EmbedWrapperDefaults >
                                        {parse(element.url, options)}
                                    </EmbedWrapperDefaults>
                            }
                        })()
                    }
                </EmbedWrapper>
            </LazyLoad>
        </div>
    );
};

const OnnetworkIframe = styled("div", {
    width: "100%",
    paddingBottom: "56% !important",
    height: "0",
    position: "relative",
    marginTop: "23px",
    minHeight: "200px",
    "&::before": {
        minHeight: "100px",
        height: "100%",
        content: '""',
        backgroundSize: "80px",
        opacity: 0.4,
        top: "0",
        left: "0",
        right: "0",
        position: "absolute",
        zIndex: 0
    },
    "iframe": {
        width: "100%",
        height: "100%",
        position: "absolute",
        left: "0",
        top: "0",
        margin: "0",
        padding: "0",
        border: "0",
        zIndex: 9
    }
});

const EmbedWrapperDefaults = styled("div", {
    margin: "0 auto !important",
    iframe: {
        maxWidth: "100%"
    },
    "@bp4": {
        maxWidth: "840px !important"
    }
})

const YTEmbedWrapper = styled("div", {
    position: "relative",
    paddingBottom: "56.25%",
    paddingTop: "25px",
    margin: "20px 0",
    "@bp4": {
        width: "861px !important",
        height: "474px",
        minHeight: "474px"
    },
    "iframe": {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%"
    }
});

const EmbedWrapper = styled("div", {
    margin: "30px auto",
    "@bp4": {
        "& > div": {
            margin: "0 auto",
            width: "auto",
            maxWidth: "840px",
            paddingBottom: "0",
            height: "auto"
        }
    }
});

export default MediaEmbed;